export interface PlanModel {
    product_id: string;
    name: string;
    marketing_features?: string[];
    prices: PlanPrice[];
}

export const mapToPlanModel = (x: any): PlanModel => {
    return {
        product_id: x.product_id,
        name: x.name,
        marketing_features: x.marketing_features,
        prices: x.prices.map(mapToPlanPriceModel),
    } as PlanModel;
}

export interface PlanPrice {
    price_id: string;
    amount: number;
    currency: string;
    type: string;
    has_trial: boolean;
    trial_days: number;
}

export const mapToPlanPriceModel = (x: any): PlanPrice => {
    return {
        price_id: x.price_id,
        amount: x.amount,
        currency: x.currency,
        type: x.type,
        has_trial: x.has_trial,
        trial_days: x.trial_days,
    } as PlanPrice;
}

export enum PlanStatus {
    ACTIVE = "active",
    INACTIVE = "inactive",
    TRAIL = "trialing",
    NO_PLAN = "no active plan found"
}

export interface UserPlanModel {
    PlanId: string,
    PriceId?: string,
    Unused_Amount?: number,
    PLanName: string,
    Status: PlanStatus,
    Price: any,
    Features: string[],
    FeatureKeys: string[],
    Quantity: number,
    AddOns: null | [],
    IsReccuring: boolean,
    IsMonthly: boolean,
    IsYearly: boolean,
    Created_At: string,
    Last_Updated_At: string,
    Start_Date: string,
    Type?: ValidityType,
    End_Date: string
}

export const mapToUserPlanModel = (x): UserPlanModel => {
    return {
        PlanId: x.plan_Id,
        PriceId: x.price_id,
        Unused_Amount: x.unused_credit,
        PLanName: x.plan_name,
        Status: x.plan_status,
        Price: x.price,
        Features: x.features || [],
        FeatureKeys: x.features_keys || [],
        Quantity: x.quantity,
        AddOns: null,
        IsReccuring: x.recurring,
        IsMonthly: x.monthly,
        IsYearly: x.yearly,
        Created_At: x.plan_created_at,
        Last_Updated_At: x.plan_updated_at,
        Start_Date: x.plan_started_at,
        End_Date: x.plan_validity,
        Type: x?.type,
    }
}
export interface NewPlanModel {
    ProductId: string,
    Name: string,
    Desc?: string,
    Price: number,
    PriceId: string,
    Features: string[],
    Quantity: number,
    Type: ValidityType,
    Selected?: boolean,
    HasTrial: boolean,
    TrialDays: number,
}
export enum ValidityType {
    ONETIME = "one_time",
    MONTHLY = "monthly",
    YEARLY = "yearly"
}


export const mapToNeWPlanModel = (x, y): NewPlanModel => {
    return {
        ProductId: x.product_id,
        Name: x.name,
        Desc: x.name === "Starter" ? "For small teams getting started" : x.name === "Growth" ? "For compliance-focused teams" : x.name === "Launch Special LTD" ? "Limited time early access" : "Customized plan",
        Features: x.marketing_features,
        PriceId: y?.price_id,
        Type: y?.type,
        Price: y?.amount / 100,
        Quantity: 1,
        HasTrial: y.has_trial,
        TrialDays: y.trial_days
    }
}
